import { observer } from 'mobx-react';
import React from 'react';
import { Table, TableCell, TableRow } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { replaceDotsAndFormatToTwoDecimalPlacesRoundingUp } from '../../util/PriceUtil';
import { Package, PackageOption } from '../MobileBusinessInterfaces';
import PackagePrice from '../selection/PackagePrice';

interface Props {
  selectedPackage: Package;
  selectedPackageOptions: PackageOption[];
}

const packageOptionRow = (key: string, optionName: string, optionPrice: string) => (
  <TableRow key={key}>
    <TableCell>
      <p className="text-small text-bold">{optionName}</p>
    </TableCell>
    <TableCell className="text-right">
      <strong className="text-small">{optionPrice}</strong>
    </TableCell>
  </TableRow>
);

@observer
class CalculationTable extends React.Component<Props> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { selectedPackage, selectedPackageOptions } = this.props;

    const data = translate('mobileBusiness.form.partitiveData', {
      capacity: selectedPackage.capacity || translate('mobileBusiness.unlimited'),
      unit: selectedPackage.capacity ? translate(`mobileBusiness.capacityUnit.${selectedPackage.capacityUnit}`) : '',
    });

    const calls = selectedPackage.calls
      ? translate('mobileBusiness.form.limitedCalls', {
          calls: selectedPackage.calls,
        })
      : translate('mobileBusiness.form.unlimitedCalls');
    const sim = translate('mobileBusiness.form.oneSimCard');

    return (
      <Table>
        <tbody>
          <TableRow>
            <TableCell>
              <p className="text-small text-bold">{translate('mobileBusiness.form.basePackage')}:</p>
              <p className="text-small">{`${data}, ${calls}${selectedPackage.isUnlimitedPlus ? '' : `, ${sim}`}`}</p>
            </TableCell>
            <TableCell>
              <PackagePrice
                mobilePackage={selectedPackage}
                packageInfoClass={'text-right'}
                priceItemClass={'text-right text-bold text-small'}
                offerPriceItemClass={'text-right text-small text-light'}
              />
            </TableCell>
          </TableRow>
          {selectedPackageOptions.map((option, index) =>
            packageOptionRow(
              `selectedOption-${index}`,
              translate(option.nameKey),
              `${replaceDotsAndFormatToTwoDecimalPlacesRoundingUp(option.price)} ${translate('mobileBusiness.eurPerMonth')}`,
            ),
          )}
        </tbody>
      </Table>
    );
  }
}

export default CalculationTable;
